import { render } from "./CollectionsBody.vue?vue&type=template&id=2dbc2d58&scoped=true"
import script from "./CollectionsBody.vue?vue&type=script&lang=js"
export * from "./CollectionsBody.vue?vue&type=script&lang=js"

import "./CollectionsBody.vue?vue&type=style&index=0&id=2dbc2d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbc2d58"]])

export default __exports__